import { useEffect } from 'react'

import { checklistStatusTypes } from 'constants/checklist'
import { getRoomName } from 'helpers/room'
import { saveUserDeviceProfile } from 'services/apis/device'
import { NETWORK_SPEED_KBPS } from 'utils/networkSpeed'

const roomName = getRoomName()

const useProfileSaver = ({ status, err, userId }) => {
    /* this useEffect will watch for update in checklist status and
       save the checklist result in the backend */
    useEffect(() => {
        if (!userId) return
        if (status === checklistStatusTypes.IN_PROGRESS) return

        const downSpeedKbps = localStorage.getItem(NETWORK_SPEED_KBPS) || 0
        const payload = {
            roomName,
            userId,
            reason: '',
            status: 'pass',
            downSpeedKbps,
            upSpeedKbps: 0,
        }

        if (status === checklistStatusTypes.ERROR) {
            payload.reason = err
            payload.status = 'fail'
        }

        saveUserDeviceProfile(payload)
    }, [status, err, userId])
}

export default useProfileSaver
